<template>
  <div>
    <v-row justify="center" :class="{'px-2': $vuetify.breakpoint.xsOnly}">
      <v-col cols="11" class="pt-0 px-0" v-if="isApproval">
        <h2 :class="{'pt-4 mb-3': $vuetify.breakpoint.mdAndUp, 'headingMobile': $vuetify.breakpoint.smAndDown}">Review
          Notification Request</h2>
        <br/>
        <v-row class="pb-6">
          <v-col cols="12" lg="6" sm="6">
            <v-row>
              <v-col cols="12">
                <div>
                  <label><strong>Requested by</strong></label>
                  <br/>
                  <span>{{ creatorName }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" lg="6" sm="6">
            <v-row>
              <v-col cols="12">
                <div>
                  <label><strong>Date requested</strong></label>
                  <br/>
                  <span>{{ approverRequestDate }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="11" :class="{'px-0 pt-0': $vuetify.breakpoint.smAndUp, 'pt-0 px-0': $vuetify.breakpoint.xsOnly}">
        <div style="display: flex; flex-direction: row; align-items: center;">
          <h2 :style="{'font-size': $vuetify.breakpoint.smAndDown ? '20px' : '24px'}"
          >{{ title }}</h2>
          <v-chip
            v-if="$store.state.detailsMode"
            :outlined="status === 'Draft'"
            :class="'chip chip' + status"
          >
            {{ status ? status.toUpperCase() : '' }}
          </v-chip>
        </div>
        <br/>
        <v-row>
          <v-col cols="12"
                 :lg="isBanner ? '12' : '6'"
                 :md="isBanner ? '12' : '6'"
                 :sm="isBanner ? '12' : '6'"
          >
            <div class="">
              <v-row>
                <v-col cols="12">
                  <div>
                    <label><strong>Notification Name</strong></label>
                    <br/>
                    <span>{{ name }}</span>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs12>
                  <div>
                    <label><strong>Delivery Method</strong></label>
                    <br/>
                    <span>{{ method }}</span>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs12>
                  <div>
                    <label><strong>Title</strong></label>
                    <br/>
                    <span>{{ message.title }}</span>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs12>
                  <div>
                    <label><strong>Message</strong></label>
                    <br/>
                    <span v-if="!isBanner">{{ message.body }}</span>
                    <div v-html="message.htmlBody" v-else></div>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="message.link">
                <v-col xs12>
                  <div>
                    <label><strong>Link</strong></label>
                    <br/>
                    <span>{{ message.link }}</span>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs12>
                  <div>
                    <label><strong>Audience</strong></label>
                    <br/>
                    <span>{{
                        audience.type === 'Everyone' ? 
                          'Send to everyone' : audience.payload ? 
                            audience.payload.slice(0, 10).join(", ") : ""
                      }}</span><br/>
                    <a 
                      v-if="isFolded && moreAudiences"
                      href="#"
                      class="text-body-1"
                      @click="isFolded = !isFolded"
                    >
                      ...show the rest {{ audience.payload.length - 10 }} members
                    </a>
                    <span v-if="!isFolded">{{ audience.payload.slice(10).join(", ") }}</span>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs12>
                  <div>
                    <label><strong>Approver</strong></label>
                    <br/>
                    <span>{{ approver ? approver.name : "" }}</span>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="scheduling.isScheduled && status !== 'Sent'">
                <v-col xs12>
                  <div>
                    <label><strong>Scheduling</strong></label>
                    <br/>
                    <span>{{ scheduling.payload }}</span>
                  </div>
                  <div class="mt-4" v-if="status !== 'Scheduled'">
                    <p style="font-size: 14px;">If the notification's approval occurs after the
                      scheduled date/time, the
                      notification is
                      going to be sent immediately after being approved.</p>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="status === 'Sent'">
                <v-col xs12>
                  <label><strong>Sent</strong></label>
                  <br/>
                  <span>{{ sentDatetime }}</span>
                </v-col>
              </v-row>
              <v-row v-if="status !== 'Draft' && approverRequestDate && !isApproval">
                <v-col xs12>
                  <label><strong>Requested approval</strong></label>
                  <br/>
                  <span>{{ approverRequestDate }}</span>
                </v-col>
              </v-row>
              <v-row v-if="!isApproval">
                <v-col xs12>
                  <div>
                    <label><strong>Created</strong></label>
                    <br/>
                    <span>{{ createdDatetime }}</span>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="6" style="height: fit-content; display: flex; justify-content: center; margin-top: -6px;" v-if="!isBanner">
            <MockPhone :body="message.body ? message.body : ''"
                       :title="message.title ? message.title : ''"/>
          </v-col>
          <v-col cols="12" v-else>
            <Alert in-page
                   type="info"
                   :title="message.title ? message.title : 'Title'"
                   :html-text="message.htmlBody ? message.htmlBody : 'Body'"
                   action-text="OK, GOT IT"
            />
          </v-col>
        </v-row>
        <v-row v-if="status === 'Rejected' && rejectionReason && $store.getters.detailsMode"
               :class="{'px-2': $vuetify.breakpoint.xsOnly}">
          <v-col
            :class="{'rounded pa-6 mt-6': $vuetify.breakpoint.mdAndUp, 'rounded pa-3 mt-2': $vuetify.breakpoint.smAndDown}"
            style="background-color: #F5F5F5;">
            <h3 class="mb-3" :style="{'font-size': $vuetify.breakpoint.mdAndUp ? '18px' : '16px'}">Rejection Reason</h3>
            <p>{{ rejectionReason }}</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MockPhone from "@/components/MockPhone";
import Alert from "@/components/Alert";
import moment from "moment";
import sanitizeHtml from 'sanitize-html';

export default {
  name: "NotificationReview",
  components: {
    MockPhone,
    Alert
  },
  props: {
    title: {
      type: String,
      default: 'Review'
    },
    isApproval: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      name: null,
      method: "",
      displayMethod: null,
      message: {
        title: null,
        body: null,
        htmlBody: null,
        link: null
      },
      audience: {
        type: null,
        payload: []
      },
      approver: null,
      scheduling: {
        isScheduled: null,
        payload: null
      },
      status: "",
      rejectionReason: null,
      sentDatetime: null,
      approverRequestDate: null,
      createdDatetime: null,
      deliveryFailures: null,
      creatorName: null,
      isFolded: true,
    }
  },
  computed: {
    isBanner() {
      return this.displayMethod === 'portal_banner';
    },
    notificationSetupDetails: {
      get() {
        return this.$store.getters.notificationSetupDetails;
      },
      set(setupDetails) {
        if (setupDetails) {
          this.name = setupDetails.name;
          this.methods = setupDetails.method.join(", ");
        }
      }
    },
    notificationMessageDetails: {
      get() {
        return this.$store.getters.notificationMessageDetails;
      },
      set(messageDetails) {
        if (messageDetails) {
          this.message.title = messageDetails.message.title;
          this.message.body = messageDetails.message.body;
          this.message.link = messageDetails.message.data.deeplink;
        }
      }
    },
    notificationAudienceAndScheduling: {
      get() {
        return this.$store.getters.notificationAudienceAndScheduling;
      },
      set(audienceAndScheduling) {
        if (audienceAndScheduling) {
          const approvers = this.$store.getters.approvers;
          this.approver = approvers.find(a => a.emailAddress === audienceAndScheduling.approverEmail);
          this.audience.type = audienceAndScheduling.audience.type;
          if (this.audience.type === 'Individuals') {
            this.audience.payload = audienceAndScheduling.audience.emails.map(email => {
              let splitEmail = email.split('@');
              return splitEmail[0];
            });
          }
          if (this.audience.type === 'Roles') this.audience.payload = audienceAndScheduling.audience.roles;
          this.scheduling.isScheduled = audienceAndScheduling.scheduling.isScheduled;
          this.scheduling.payload = audienceAndScheduling.scheduling.payload ? this.formatDate(audienceAndScheduling.scheduling.payload) : null;
        }
      }
    },
    notificationInfo: {
      get() {
        return this.$store.getters.notificationInfo;
      },
      set(generalInfo) {
        this.approverRequestDate = this.formatDate(generalInfo.approverRequestDate);
      }
    },
    moreAudiences() {
      return this.audience.payload.length > 10;
    }
  },
  methods: {
    formatDate(date) {
      date = moment(new Date(date)).format("DD/MM/YYYY hh:mm a").split(" ");
      const scheduledDate = date[0];
      let scheduledTime = date[1];
      return `${scheduledDate} at ${scheduledTime} ${date[2].toUpperCase()}`
    },
  },
  created() {
    if (this.notificationInfo) {
      this.status = this.$store.getters.currentNotification.status;
      this.rejectionReason = this.$store.getters.currentNotification.rejectionReason;
      this.sentDatetime = this.$store.getters.currentNotification.sentDatetime ? this.formatDate(this.$store.getters.currentNotification.sentDatetime) : null;
      this.approverRequestDate = this.$store.getters.currentNotification.approverRequestDate ? this.formatDate(this.$store.getters.currentNotification.approverRequestDate) : null;
      this.createdDatetime = this.formatDate(this.$store.getters.currentNotification.createdDatetime);
      this.creatorName = this.$store.getters.currentNotification.creatorName;
    }
    if (this.notificationSetupDetails) {
      this.name = this.notificationSetupDetails.name;
      this.displayMethod = this.notificationSetupDetails.displayMethod;
      switch (this.notificationSetupDetails.method) {
        case 'syssend':
          this.method = 'Inbox & Push';
          break;
        case 'websend':
          if (this.displayMethod === 'portal_banner') {
            this.method = "Banner";
          } else {
            this.method = "Inbox";
          }
      }
    }
    if (this.notificationMessageDetails) {
      this.message.title = this.notificationMessageDetails.message.title;
      this.message.body = this.notificationMessageDetails.message.body;
      this.message.htmlBody = sanitizeHtml(this.notificationMessageDetails.message.htmlBody);
      this.message.link = this.notificationMessageDetails.message.data.deeplink;
    }
    if (this.notificationAudienceAndScheduling) {
      const approvers = this.$store.getters.approvers;
      if (approvers.length === 0) {
        this.$store.dispatch('fetchApprovers')
          .catch(error => this.$log.error(error))
          .then(() => {
            this.approver = this.$store.getters.approvers.find(a => a.emailAddress === this.notificationAudienceAndScheduling.approverEmail);
          })
      } else {
        this.approver = approvers.find(a => a.emailAddress === this.notificationAudienceAndScheduling.approverEmail);
      }
      this.audience.type = this.notificationAudienceAndScheduling.audience.type;
      if (this.audience.type === 'Individuals') {
        this.audience.payload = this.notificationAudienceAndScheduling.audience.emails.map(email => {
          let splitEmail = email.split('@');
          return splitEmail[0];
        });
      }
      if (this.audience.type === 'Roles') {
        this.audience.payload = this.notificationAudienceAndScheduling.audience.roles;
      }

      this.scheduling.isScheduled = this.notificationAudienceAndScheduling.scheduling.isScheduled;
      this.scheduling.payload = this.notificationAudienceAndScheduling.scheduling.payload ? this.formatDate(this.notificationAudienceAndScheduling.scheduling.payload) : null;
    }
  }
}
</script>

<style scoped>
.chip {
  width: 120px;
  height: 24px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  margin-left: 12px;
}

.chipPending {
  background-color: #C8DCF0 !important;
  color: #041E42 !important;
  border-color: #C8DCF0 !important;
}

.chipSent {
  background-color: #00A908 !important;
  color: #FFFFFF !important;
  border-color: #00A908 !important;
}

.chipScheduled {
  background-color: #2E5299 !important;
  color: #FFFFFF !important;
  border-color: #2E5299 !important;
}

.chipRejected {
  background-color: #B81237 !important;
  color: #FFFFFF !important;
  border-color: #B81237 !important;
}

.chipDraft {
  background-color: #FFFFFF !important;
  color: #041E42 !important;
  border-color: #041E42 !important;
}

.headingDeskTop {
  font-size: 20px;
}

.headingMobile {
  font-size: 20px;
}
</style>
